export function rescaleJobRunningPercentage(x: number) {
  const rescaledValue = (x * 90) / 100;
  return Math.round(rescaledValue);
}
